import React, { useState } from 'react';
import {
    Modal, ProgressLinear, ModalBody, Label
} from '@americanexpress/dls-react';

function Loading({ showModal }) {
    const [show, setShow] = useState(showModal);
    const closeModal = () => setShow(false);
    return (
        <div>
            {show && (
                <div>
                    <Modal onClose={closeModal}>                        
                        <ModalBody>
                            <div className="pad-4">
                                <div className="container">
                                    <div className="row flex flex-justify-center">
                                        <Label>Please wait while your application is getting processed and don't press back button.</Label>
                                      </div>
                                </div>
                            </div>
                            <ProgressLinear />
                        </ModalBody>
                    </Modal></div>
            )}
        </div>

    );
}
export default Loading;